// 质押式回购额外盘口信息
import { Observer } from "mobx-react-lite"
import React from "react"
import { PageType } from "../../shared/pagetype"
import { single_quote, quote_item_name, quote_chart } from "../../shared/quotedata/index"
import { ChartType } from "../../shared/utils"

export function BondExtraPanKou(props: { detail_data: any; chart_mouse_move_data: any; chartType: ChartType; pagetype: PageType }) {
  return (
    <Observer>
      {() => (
        <ul className="bond-extra-pankou">
          {props.chart_mouse_move_data && !(props.chartType == ChartType.分时 || props.chartType == ChartType.五日) ? (
            <>
              <li>
                <span>今开</span>
                {quote_chart[quote_item_name.今开](props.chart_mouse_move_data.jinkai, props.chart_mouse_move_data.jkColor).element}
              </li>
              <li>
                <span>最高</span>
                {quote_chart[quote_item_name.最高](props.chart_mouse_move_data.maxPrice, props.chart_mouse_move_data.maxPriceColor).element}
              </li>
            </>
          ) : (
            <>
              <li>
                <span>今开</span>
                {single_quote[quote_item_name.今开](props.detail_data).element}
              </li>
              <li>
                <span>最高</span>
                {single_quote[quote_item_name.最高](props.detail_data).element}
              </li>
            </>
          )}
          {props.chart_mouse_move_data ? (
            <li>
              <span>成交量</span>
              {quote_chart[quote_item_name.成交量](props.chart_mouse_move_data.volume).element}
            </li>
          ) : (
            <li>
              <span>成交量</span>
              {single_quote[quote_item_name.成交量](props.detail_data).new_bond_element}
            </li>
          )}
          {props.chart_mouse_move_data && (props.chartType == ChartType.分时 || props.chartType == ChartType.五日) ? (
            <li>
              <span>均价</span>
              {quote_chart[quote_item_name.均价](props.chart_mouse_move_data.average_price, props.chart_mouse_move_data._color).element}
            </li>
          ) : (
            <li>
              <span>均价</span>
              {single_quote[quote_item_name.均价](props.detail_data).element}
            </li>
          )}
          {props.chart_mouse_move_data && !(props.chartType == ChartType.分时 || props.chartType == ChartType.五日) ? (
            <li>
              <span>最低</span>
              {quote_chart[quote_item_name.最低](props.chart_mouse_move_data.minPrice, props.chart_mouse_move_data.minPriceColor).element}
            </li>
          ) : (
            <li>
              <span>最低</span>
              {single_quote[quote_item_name.最低](props.detail_data).element}
            </li>
          )}
          {props.chart_mouse_move_data ? (
            <li>
              <span>成交额</span>
              {quote_chart[quote_item_name.成交额](props.chart_mouse_move_data.amount).new_bond_element}
            </li>
          ) : (
            <li>
              <span>成交额</span>
              {single_quote[quote_item_name.成交额](props.detail_data).new_bond_element}
            </li>
          )}
        </ul>
      )}
    </Observer>
  )
}
